import React from 'react'

import clsx from 'clsx'

import Card, { CardMedia } from 'components/Card'
import NextImage from 'components/NextImage'
import Tag from 'components/Tag'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import openUrl from 'helpers/openUrl'
import { useDate } from 'hooks/useDate/useDate'
import { ROUTE_NAMES } from 'routes'
import routeService from 'services/routes'

import classes from './ArticleCardLarge.module.scss'

/** @type {import("./types").default} */
const ArticleCardLarge = ({ className, post }) => {
  const { addEvent } = useEventContext()
  const { getDate } = useDate()

  const tag = {
    label: post.topic.name,
    slug: post.topic.slug,
    colorVariant: 'teal',
    url: routeService.generatePath(ROUTE_NAMES.RESOURCES_TOPIC, { slug: post.topic.slug }),
    engagementDestination: 'go-to_topic',
    engagementDetails: 'chip_topic-link',
  }

  return (
    <Card
      className={clsx('ArticleCardLarge', className, classes.root)}
      onClick={() =>
        openUrl(routeService.generatePath(ROUTE_NAMES.RESOURCES_POST, { slug: post.permalink }), {
          rel: null,
          target: '_self',
        })
      }
      {...addEvent({
        name: 'engagement_facet_click',
        engagementComponent: 'related-article',
        engagementDestination: 'go-to_article',
        engagementDetails: 'card_article',
      })}
    >
      <div className={classes.card}>
        <div className={classes.content}>
          {tag && (
            <Tag
              color={tag.colorVariant}
              size="small"
              href={tag.url}
              onClick={e => e.stopPropagation()}
              {...addEvent({
                engagementComponent: 'related-article',
                engagementDestination: tag.engagementDestination,
                engagementDetails: tag.engagementDetails,
                name: 'engagement_facet_click',
              })}
            >
              {tag.label}
            </Tag>
          )}
          <Typography
            variant="caption-default"
            className={classes.title}
            href={routeService.generatePath(ROUTE_NAMES.RESOURCES_POST, { slug: post.permalink })}
            component="a"
          >
            {post.title}
          </Typography>
          <Typography className={classes.info} variant="body-xs">
            {post.readingTime ? `${post.readingTime} min read - ` : ''}
            {getDate(post.publishDate).format('MMM DD, YYYY')}
          </Typography>
        </div>
        {post.titleImage && (
          <CardMedia className={classes.imageDiv}>
            <NextImage src={post.titleImage.url} alt={`${post.slug}-image`} width={640} height={395} loading="lazy" />
          </CardMedia>
        )}
      </div>
    </Card>
  )
}

export default ArticleCardLarge
